import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import telegramService from "../../utils/telegram";

interface SelectCardProps {
  selected: boolean;
  onClick: () => void;
  icon: string;
  title: string;
  description?: string;
  /** Kichik grid kartalar uchun (masalan 3 ustunli goal tanlovi) */
  compact?: boolean;
  index?: number;
}

/** Wizard qadamlaridagi yagona tanlov kartasi */
const SelectCard: React.FC<SelectCardProps> = ({
  selected,
  onClick,
  icon,
  title,
  description,
  compact = false,
  index = 0,
}) => {
  const handleClick = () => {
    telegramService.haptic("selection");
    onClick();
  };

  if (compact) {
    return (
      <motion.button
        type="button"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.05 * index, duration: 0.3 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
        className={`p-3 rounded-2xl border-2 text-center transition-all ${
          selected
            ? "border-brand-500 bg-brand-soft shadow-soft"
            : "border-line bg-surface shadow-card"
        }`}
      >
        <div className="text-xl mb-1">{icon}</div>
        <div
          className={`text-xs font-bold leading-tight ${
            selected ? "text-brand-text" : "text-content-primary"
          }`}
        >
          {title}
        </div>
      </motion.button>
    );
  }

  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.05 * index, duration: 0.3 }}
      whileTap={{ scale: 0.97 }}
      onClick={handleClick}
      className={`relative p-4 rounded-2xl border-2 flex items-center gap-4 text-left transition-all ${
        selected
          ? "border-brand-500 bg-brand-soft shadow-soft"
          : "border-line bg-surface shadow-card"
      }`}
    >
      <div className="text-2xl bg-surface-2 p-2 rounded-xl shrink-0">{icon}</div>
      <div className="flex-1 min-w-0">
        <div
          className={`text-sm font-bold ${
            selected ? "text-brand-text" : "text-content-primary"
          }`}
        >
          {title}
        </div>
        {description && (
          <p className="text-[11px] text-content-tertiary font-medium leading-tight mt-0.5">
            {description}
          </p>
        )}
      </div>
      {selected && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="w-5 h-5 rounded-full bg-brand-500 flex items-center justify-center text-white shrink-0"
        >
          <Check size={12} strokeWidth={3} />
        </motion.div>
      )}
    </motion.button>
  );
};

export default SelectCard;
